import { defineComponent as _defineComponent } from 'vue'
import { PropType } from "vue";


const __default__ = {
  name: "Tabs",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  tabList: {
    type: Array as PropType<string[]>,
  },
  currentTabIndex: {
    type: Number,
  },
},
  emits: ["onChangeTab"],
  setup(__props, { expose: __expose, emit: __emit }) {



const emit = __emit;

const onChangeTab = (tabIndex: number) => {
  emit("onChangeTab", tabIndex);
};

const changeTabIndex = (index: number) => {
  onChangeTab(index);
};

__expose({ changeTabIndex });

const __returned__ = { emit, onChangeTab, changeTabIndex }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})